export interface SigninInput {
  email: string;
  password: string;
}

export interface IUser {
  _id: string;
  username: string;
  email: string;
  role: ERole;
  active: boolean;
  preference?: any;
  avatarPath?: string;
  backgroundPath?: string;
  expiredTime?: string;
  isDeleted?: boolean;
  personalization?: any;
  password?: string;
  status?: boolean;
  isPremium?: boolean;
  currentPackage?: any;
  group?: any;
  monthlyQuotaUsed?: number;
  monthlyQuotaLimit?: number;
  lastQuotaRefreshDate?: string;
  nextQuotaRefreshDate?: string;
  quotaResetAnchorDate?: string;
  toppedUpBalance?: number;
}

export interface IEditInfoUser {
  username: string;
  email: string;
  password: string;
  newPassword: string;
  preference: Array<any>;
  avatar: File;
  isChangePassword: boolean;
  avatarPath?: string;
  personalization?: any;
}

export interface IChangeStatus {
  id: string;
  status: boolean;
}

export interface ICreateMultipleUser {
  groupId?: string | null;
  users: {
    username: string;
    email: string;
    active: boolean;
  }[];
}

export enum ERole {
  ADMIN = "admin",
  SUPER_ADMIN = "super_admin",
  USER = "user",
  TEACHER = "teacher",
}

export interface IBulkUpdateExpiredTime {
  userIds: string[];
  expiredTime: string;
}
